<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-sequence2-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-sequence2-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.4992867761164;"
    data-aspect-ratio="0.499"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-sequence2-xs-img"
      class="g-sequence2-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence2-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.805%;margin-top:-8.5px;left:81.1603%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">00:07</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:7.1233%;margin-top:-9.1px;left:20.8008%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle1">ICE agent 2</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:28.6078%;margin-top:-9.1px;left:52.7209%;margin-left:-96.5px;width:193px;"
    >
      <p class="g-pstyle2">ICE agents exit their vehicle.</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.5447%;margin-top:-8.5px;left:81.3616%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle0">00:11</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:37.6857%;margin-top:-9.1px;left:11.2929%;width:91px;"
    >
      <p class="g-pstyle3">ICE agent 2</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5604%;margin-top:-9.1px;left:23.0936%;width:91px;"
    >
      <p class="g-pstyle3">ICE agent 3</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5604%;margin-top:-9.1px;left:52.4648%;width:85px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:62.3475%;margin-top:-9.1px;left:52.673%;margin-left:-109.5px;width:219px;"
    >
      <p class="g-pstyle2">The agents approach Good&rsquo;s car.</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.1331%;margin-top:-8.5px;left:81.5942%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:12</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:95.9358%;margin-top:-9.1px;left:52.7589%;margin-left:-108px;width:216px;"
    >
      <p class="g-pstyle2">Agent tries to open Good&rsquo;s door.</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-sequence2-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.77073551773669;"
    data-aspect-ratio="0.771"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-sequence2-sm-img"
      class="g-sequence2-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence2-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.8018%;margin-top:-8.5px;left:70.1626%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">00:07</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:7.1151%;margin-top:-9.1px;left:31.3025%;margin-left:-45.5px;width:91px;"
    >
      <p class="g-pstyle1">ICE agent 2</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:28.5748%;margin-top:-9.1px;left:51.7605%;margin-left:-96.5px;width:193px;"
    >
      <p class="g-pstyle2">ICE agents exit their vehicle.</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.5026%;margin-top:-8.5px;left:70.2928%;margin-left:-25px;width:50px;"
    >
      <p class="g-pstyle0">00:11</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:37.6423%;margin-top:-9.1px;left:25.1503%;width:91px;"
    >
      <p class="g-pstyle3">ICE agent 2</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5136%;margin-top:-9.1px;left:32.7861%;width:91px;"
    >
      <p class="g-pstyle3">ICE agent 3</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5136%;margin-top:-9.1px;left:51.987%;width:85px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:62.2756%;margin-top:-9.1px;left:51.7295%;margin-left:-109.5px;width:219px;"
    >
      <p class="g-pstyle2">The agents approach Good&rsquo;s car.</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.0522%;margin-top:-8.5px;left:70.4433%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:12</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:95.8253%;margin-top:-9.1px;left:51.7852%;margin-left:-108px;width:216px;"
    >
      <p class="g-pstyle2">Agent tries to open Good&rsquo;s door.</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-sequence2-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.99802211786708;"
    data-aspect-ratio="0.998"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-sequence2-md-img"
      class="g-sequence2-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence2-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.6648%;margin-top:-9.6px;left:65.125%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle0">00:07</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:6.9807%;margin-top:-10.2px;left:36.0249%;margin-left:-50.5px;width:101px;"
    >
      <p class="g-pstyle1">ICE agent 2</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:28.4533%;margin-top:-10.2px;left:50.8838%;margin-left:-108.5px;width:217px;"
    >
      <p class="g-pstyle2">ICE agents exit their vehicle.</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.5371%;margin-top:-9.6px;left:65.2814%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">00:11</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:37.6775%;margin-top:-10.2px;left:29.7374%;width:101px;"
    >
      <p class="g-pstyle3">ICE agent 2</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5506%;margin-top:-10.2px;left:36.0923%;width:101px;"
    >
      <p class="g-pstyle3">ICE agent 3</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:40.5506%;margin-top:-10.2px;left:50.7858%;width:94px;"
    >
      <p class="g-pstyle3">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:62.1743%;margin-top:-10.2px;left:50.8779%;margin-left:-123.5px;width:247px;"
    >
      <p class="g-pstyle2">The agents approach Good&rsquo;s car.</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:69.9557%;margin-top:-9.6px;left:65.2956%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:12</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:95.7442%;margin-top:-10.2px;left:50.8839%;margin-left:-121.5px;width:243px;"
    >
      <p class="g-pstyle2">Agent tries to open Good&rsquo;s door.</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-sequence2-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 4.36619718309859;"
    data-aspect-ratio="4.366"
    data-min-width="930"
  >
    <div
      id="g-sequence2-lg-img"
      class="g-sequence2-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence2-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.804%;margin-top:-9.6px;left:27.3046%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle0">00:07</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.804%;margin-top:-9.6px;left:63.4156%;margin-left:-27.5px;width:55px;"
    >
      <p class="g-pstyle0">00:11</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.804%;margin-top:-9.6px;left:95.0127%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:12</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:9.4667%;margin-top:-10.2px;left:36.0131%;width:101px;"
    >
      <p class="g-pstyle1">ICE agent 2</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:20.2648%;margin-top:-10.2px;left:51.3004%;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:20.2648%;margin-top:-10.2px;left:41.0607%;width:101px;"
    >
      <p class="g-pstyle1">ICE agent 3</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:20.7343%;margin-top:-10.2px;left:2.8838%;width:101px;"
    >
      <p class="g-pstyle1">ICE agent 2</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:87.8703%;margin-top:-10.2px;left:16.7704%;margin-left:-108.5px;width:217px;"
    >
      <p class="g-pstyle2">ICE agents exit their vehicle.</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:87.8703%;margin-top:-10.2px;left:48.9887%;margin-left:-123.5px;width:247px;"
    >
      <p class="g-pstyle2">The agents approach Good&rsquo;s car.</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:87.8703%;margin-top:-10.2px;left:82.9661%;margin-left:-121.5px;width:243px;"
    >
      <p class="g-pstyle2">Agent tries to open Good&rsquo;s door.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 16:27 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 16:27 -->
<!-- ai file: sequence2.ai -->
<style lang="scss">
  #g-sequence2-box {
    container-type: inline-size;
    container-name: g-sequence2-box;
  }
  #g-sequence2-box,
  #g-sequence2-box .g-artboard {
    margin: 0 auto;
  }
  #g-sequence2-box p {
    margin: 0;
  }
  #g-sequence2-box .g-aiAbs {
    position: absolute;
  }
  #g-sequence2-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-sequence2-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-sequence2-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence2-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence2-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-sequence2-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-sequence2-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-sequence2-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-sequence2-lg {
        display: block !important;
      }
    }
  }
  #g-sequence2-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence2-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence2-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence2-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-xs .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence2-xs .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence2-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence2-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence2-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-sm .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence2-sm .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence2-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence2-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence2-md .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-md .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }
  #g-sequence2-md .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence2-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-sequence2-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence2-lg .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    color: rgb(255, 212, 48);
  }
  #g-sequence2-lg .g-pstyle2 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
